
import api from "@/api"
export const telBehavior = {
  bind: function (el, binding) {
    let { value = {} } = binding;
    el.addEventListener('click', evt => {
      if (value && value.goodsId && value.goodsIdType && value.sourceType && value.functionId) {
        api.mogoroomRenterBehavior.addUserBehavior({
          goodsId: value.goodsId, //房源ID
          goodsIdType: value.goodsIdType, //roomId类型 1:房间ID 2:房型ID
          sourceType: value.sourceType,  //数据来源
          functionId: value.functionId //来源页面Id,二房东详情页面为2,经纪人详情页面为8,个人中心-我的预约页面为9
        });
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/directives/telBehavior.js